import { loadStripe } from "@stripe/stripe-js";

// ⚠️ Reemplaza esto con tu clave pública de pruebas de Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default stripePromise;
